import { FC } from "react";
import { Grid } from "@mui/material";
import BasicKPIComponent from "../../../../Dashboard/BasicKPIComponent";
import EmojiBadge from "./EmojiBadge";
import {
	IndependentKpis,
	ScoredSumKpis,
} from "../../../../../services/reports.service";

interface ScoredSumKpiRowProps {
	mode: "scoredSum";
	kpis: ScoredSumKpis;
}

interface IndependentKpiRowProps {
	mode: "independent";
	kpis: IndependentKpis;
	emojiValues: string[];
}

type EventRatingsKpiRowProps = ScoredSumKpiRowProps | IndependentKpiRowProps;

const formatScore = (v: number | null): string =>
	v === null ? "—" : v.toFixed(1);

const formatPct = (v: number | null): string =>
	v === null ? "—" : `${v.toFixed(1)}%`;

const EventRatingsKpiRow: FC<EventRatingsKpiRowProps> = (props) => {
	if (props.mode === "scoredSum") {
		const { kpis } = props;
		return (
			<Grid container spacing={2}>
				<BasicKPIComponent
					title="Avg score day 1"
					content={formatScore(kpis.avgScoreDay1)}
					footer={{ hidden: true }}
				/>
				<BasicKPIComponent
					title="Avg score day 14"
					content={formatScore(kpis.avgScoreDay14)}
					footer={{ hidden: true }}
				/>
				<BasicKPIComponent
					title="Avg improvement"
					content={formatPct(kpis.improvementPct)}
					footer={{ hidden: true }}
				/>
				<BasicKPIComponent
					title="Submission rate"
					content={`${kpis.submissionRate.toFixed(1)}%`}
					footer={{ hidden: true }}
				/>
			</Grid>
		);
	}

	const { kpis, emojiValues } = props;
	const topEmoji = kpis.mostCommonEmojiDay1;
	return (
		<Grid container spacing={2}>
			<BasicKPIComponent
				title="Avg distress day 1"
				content={formatScore(kpis.avgDistressDay1)}
				footer={{ hidden: true }}
			/>
			<BasicKPIComponent
				title="Avg distress day 14"
				content={formatScore(kpis.avgDistressDay14)}
				footer={{ hidden: true }}
			/>
			<BasicKPIComponent
				title="Most common emoji (day 1)"
				content={
					topEmoji ? (
						<EmojiBadge value={topEmoji.value} values={emojiValues} />
					) : (
						"—"
					)
				}
				footer={{ hidden: true }}
			/>
			<BasicKPIComponent
				title="Submission rate"
				content={`${kpis.submissionRate.toFixed(1)}%`}
				footer={{ hidden: true }}
			/>
		</Grid>
	);
};

export default EventRatingsKpiRow;
